import { render, staticRenderFns } from "./VTextField.vue?vue&type=template&id=16cd823f&scoped=true"
import script from "./VTextField.vue?vue&type=script&lang=js"
export * from "./VTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd823f",
  null
  
)

export default component.exports